'use strict';

var utils = require('../util/utils');

module.exports = class ProductTile {
    selector = {
        tile: '.product-tile',
        actualName: '.actual-name',
        greyButton: '.grey-button',
        shortDescription: '.product-short-description',
        actualNameInner: '.product-name .actual-name',
        hoverText: '.product-name .hover-text',
        tileLinkBottom: '.tile-link-bottom',
        hoverTextSpan: '.hover-text span'
    }

    constructor() {
        this.init();
    }

    init() {
        this.initializeTiles();
        this.bindEvents();
    }

    initializeTiles() {
        var self = this;
        $(self.selector.tile).each(function () {
            var $this = $(this);
            if (!($this.hasClass('initialized'))) {
                $this.addClass('initialized');
                var $actualName = $this.find(self.selector.actualName);
                var $subject = $this.find(self.selector.greyButton);
                self.addManyLinesClass($actualName);
                self.addManyLinesClass($subject);
            }
        });
    }

    addManyLinesClass($selector) {
        if (!$selector.length) return;
        var offsetHeight = $selector[0].offsetHeight;
        var scrollHeight = $selector[0].scrollHeight;
        if (scrollHeight > offsetHeight) $selector.addClass('many-lines');
    }

    bindEvents() {
        var isDesktop = utils.mediaBreakpointUp('md');
        if (isDesktop) {
            this.bindDesktopEvents();
        } else {
            this.bindMobileEvents();
        }
    }

    bindDesktopEvents() {
        var self = this;
        $('body').on('mouseenter', self.selector.tile, function () {
            $(this).find(self.selector.shortDescription).addClass('d-block');
            $(this).find(self.selector.actualNameInner).addClass('d-none').removeClass('d-flex');
            $(this).find(self.selector.hoverText).addClass('d-flex').removeClass('d-none');
            $(this).find(self.selector.tileLinkBottom).addClass('hovered');
            var $hoverText = $(this).find(self.selector.hoverTextSpan);
            self.addManyLinesClass($hoverText);
        }).on('mouseleave', self.selector.tile, function () {
            $(this).find(self.selector.shortDescription).removeClass('d-block');
            var $actualName = $(this).find(self.selector.actualNameInner);
            if (!$actualName.hasClass('many-lines')) {
                $actualName.addClass('d-flex');
            }
            $(this).find(self.selector.hoverText).addClass('d-none').removeClass('d-flex');
            $(this).find(self.selector.actualNameInner).removeClass('d-none');
            $(this).find(self.selector.tileLinkBottom).removeClass('hovered');
        });
    }

    bindMobileEvents() {
        var self = this;
        $('body').on('click', self.selector.tile, function () {
            $(this).find(self.selector.shortDescription).addClass('d-block');
        }).on('blur', self.selector.tile, function () {
            $(this).find(self.selector.shortDescription).removeClass('d-block');
        });
    }
};
